<div class="page">
    <div class="page-head">
        <div>
            <h2>{{ pageTitle() }}</h2>
            <p>Send messages over Email, SMS or WhatsApp and track their delivery.</p>
        </div>
        <p-button label="Send Notification" icon="pi pi-send" (onClick)="openSend()" />
    </div>

    <div class="card">
        <p-table [value]="items()" [loading]="loading()" dataKey="id" [rows]="10"
            [paginator]="items().length > 10" [rowsPerPageOptions]="[10, 25, 50]"
            styleClass="p-datatable-sm" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
            <ng-template pTemplate="header">
                <tr>
                    <th>Channel</th>
                    <th>Recipient</th>
                    <th>Subject</th>
                    <th>Status</th>
                    <th class="ta-r">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-n>
                <tr>
                    <td class="chan"><i class="pi pi-circle-fill"></i> {{ channelLabel(n.channel) }}</td>
                    <td class="mono">{{ n.recipient || '—' }}</td>
                    <td class="muted ellipsis">{{ n.subject || '—' }}</td>
                    <td><p-tag [value]="n.status || 'Unknown'" [severity]="statusSeverity(n.status)" /></td>
                    <td class="ta-r">
                        <p-button icon="pi pi-replay" [rounded]="true" [text]="true" severity="secondary"
                            pTooltip="Retry" (onClick)="retry(n)" />
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5">
                        <div class="state"><i class="pi pi-inbox"></i><p>No notifications yet.</p></div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- ===================== SEND MODAL ===================== -->
<p-dialog [visible]="showModal()" (visibleChange)="showModal.set($event)" [modal]="true"
    [draggable]="true" [resizable]="false" [closable]="true" [dismissableMask]="false"
    header="Send Notification" styleClass="menu-dialog" [style]="{ width: '500px' }"
    [breakpoints]="{ '480px': '94vw' }">
    <form [formGroup]="form" class="menu-form">
        <div class="field">
            <label>Channel <span class="req">*</span></label>
            <div class="chan-picker">
                @for (c of channels; track c.value) {
                    <label class="chan-opt" [class.active]="+form.get('channel')?.value === c.value">
                        <input type="radio" formControlName="channel" [value]="c.value">
                        <i [class]="c.icon"></i> {{ c.label }}
                    </label>
                }
            </div>
        </div>

        <div class="field">
            <label>Recipient <span class="req">*</span></label>
            <input pInputText type="text" formControlName="recipient" placeholder="email / phone number">
            @if (form.get('recipient')?.touched && form.get('recipient')?.invalid) {
                <small class="err">Recipient is required</small>
            }
        </div>

        <div class="field">
            <label>Subject</label>
            <input pInputText type="text" formControlName="subject" placeholder="Optional subject">
        </div>

        <div class="field">
            <label>Message <span class="req">*</span></label>
            <textarea pTextarea formControlName="body" rows="4" placeholder="Your message..."></textarea>
            @if (form.get('body')?.touched && form.get('body')?.invalid) {
                <small class="err">Message is required</small>
            }
        </div>

        <div class="field">
            <label>Schedule for <small class="muted">(leave empty to send now)</small></label>
            <input pInputText type="datetime-local" formControlName="scheduledAt">
        </div>

        <div class="modal-actions">
            <p-button label="Cancel" [outlined]="true" (onClick)="closeModal()" />
            <p-button label="Send" icon="pi pi-send" (onClick)="send()" [loading]="sending()" />
        </div>
    </form>
</p-dialog>
